[
    {
        "itemId": "A1001001A24E24C10130I06785",
        "createTs": "2024-05-24T19:01:30.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A24E03B30623E99723",
        "createTs": "2024-05-03T11:06:23.000+02:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A24A15B72731C09731",
        "createTs": "2024-01-15T16:27:31.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A23E29A80655H43632",
        "createTs": "2023-05-29T06:06:55.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A23D27B24027E43311",
        "createTs": "2023-04-27T10:40:27.000+02:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A23A17B75928A83474",
        "createTs": "2023-01-17T16:59:28.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A22E13C01543F75908",
        "createTs": "2022-05-13T18:15:43.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A22D19B04627I45403",
        "createTs": "2022-04-19T08:46:27.000+02:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A22A13C02701F31220",
        "createTs": "2022-01-13T19:27:01.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A21E17B24316J04846",
        "createTs": "2021-05-17T10:43:16.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A21A12B65247B56201",
        "createTs": "2021-01-12T15:52:47.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A20E13B14820A59686",
        "createTs": "2020-05-13T09:48:20.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A20A15A90228D31001",
        "createTs": "2020-01-15T08:02:28.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A19E10B31534I70775",
        "createTs": "2019-05-10T11:15:34.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A19C29B05510F43886",
        "createTs": "2019-03-29T09:55:10.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A19A14B41622A99772",
        "createTs": "2019-01-14T13:16:22.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A18E15A90127A10726",
        "createTs": "2018-05-15T07:01:27.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A18A15B40416F94011",
        "createTs": "2018-01-15T13:04:16.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A17E15B25126A79153",
        "createTs": "2017-05-15T10:51:26.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A17A17A70333I07219",
        "createTs": "2017-01-17T06:03:33.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A16E13B05033G53203",
        "createTs": "2016-05-13T08:50:33.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A16C29B35517I68033",
        "createTs": "2016-03-29T11:55:17.000+02:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A16A27B43911J05077",
        "createTs": "2016-01-27T13:39:11.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A15G02B45808H70060",
        "createTs": "2015-07-02T12:58:08.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A15A22B31330E72372",
        "createTs": "2015-01-22T12:13:30.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A14E27B40219F16191",
        "createTs": "2014-05-27T12:02:19.000+02:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A14E15B40627D62509",
        "createTs": "2014-05-15T12:06:27.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A14A27B44122G11786",
        "createTs": "2014-01-27T13:41:22.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A13E16C11947F82614",
        "createTs": "2013-05-16T19:19:47.000+02:00",
        "classid": 7,
        "subclassid": 8,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "V\u00fdro\u010dn\u00fd list"
    },
    {
        "itemId": "A1001001A13C27B34828H58088",
        "createTs": "2013-03-27T12:48:28.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A13B04A80332F17443",
        "createTs": "2013-02-04T07:03:32.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A12A20B44221G82057",
        "createTs": "2012-01-20T13:42:21.000+01:00",
        "classid": 183,
        "subclassid": null,
        "visible": true,
        "classidLabel": "Dynamika",
        "subclassidLabel": null
    },
    {
        "itemId": "A1001001A12A18B45711C76902",
        "createTs": "2012-01-18T13:57:11.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A11B16B52409J74889",
        "createTs": "2011-02-16T14:24:10.000+01:00",
        "classid": 7,
        "subclassid": 1,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Dodatok"
    },
    {
        "itemId": "A1001001A11A18B53228G69974",
        "createTs": "2011-01-18T14:32:28.000+01:00",
        "classid": 183,
        "subclassid": null,
        "visible": true,
        "classidLabel": "Dynamika",
        "subclassidLabel": null
    },
    {
        "itemId": "A1001001A10D12B35707B52605",
        "createTs": "2010-04-12T11:57:07.000+02:00",
        "classid": 7,
        "subclassid": 2,
        "visible": true,
        "classidLabel": "Poistn\u00e1 zmluva",
        "subclassidLabel": "Zmluva"
    }
]